import { AUTHENTICATION_SERVICE } from '@my-backoffice/app/shared/auth/authentication.token';
import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthoritiesGuard implements CanActivate {
  private readonly _authenticationService = inject(AUTHENTICATION_SERVICE);

  public async canActivate(): Promise<boolean> {
    await this._authenticationService.restoreUserDataToSession();

    if (this._authenticationService.isValidSession()) {
      return true;
    }

    this._authenticationService.navigateToLogin();

    return false;
  }
}
